import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react";

export const SpanIconCheckAvatar = () => {
  return (
    <Fragment>
      <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-primary-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
        <FontAwesomeIcon
          icon={faCheck}
          className="h-4 w-4"
          aria-hidden="true"
        />
      </span>
    </Fragment>
  );
};
